import debug from 'debug';
import { REHYDRATE } from 'redux-persist';
import { SET_CURSOR } from '../../actions/ui/cursorTables';

import {
  tableIds,
  takeBase,
  takeModal,
  takeModalSurveillanceRoute,
} from '../../../components/display/tables/types';

const log = debug('rois:state:cursor-tables');

if (import.meta.env.DEV) {
  debug.enable('rois:state:cursor-tables*');
}

export const initialCursorState = {
  [tableIds.DUPLICATE_COMMUNICATION]: {
    id: tableIds.DUPLICATE_COMMUNICATION,
    take: takeBase,
    cursor: '',
    description: undefined,
    roadId: undefined,
    concessionId: undefined,
    interlocutorGroupId: undefined,
    fromDate: undefined,
    toDate: undefined,
    orderBy: 'desc',
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
  },
  [tableIds.WORKORDER_COMMUNICATIONS]: {
    id: tableIds.WORKORDER_COMMUNICATIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    roadId: undefined,
    concessionId: undefined,
    interlocutorGroupId: undefined,
    fromDate: undefined,
    toDate: undefined,
    orderBy: 'desc',
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerId: undefined,
    // Fase 4 nav Trabajo/Revisión — filtro "Origen" (tabla GLOBAL).
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Pestaña "Comunicacions" del LISTADO de Campañas (`GeneralViewCampaignPage`)
  // — espejo de WORKORDER_COMMUNICATIONS pero con `containerTypes` (filtro
  // por TIPO de origen, no por una campaña concreta), mismo criterio que
  // RV_ACTIONS/RV_MULTIMEDIA.
  [tableIds.CAMPAIGN_LIST_COMMUNICATIONS]: {
    id: tableIds.CAMPAIGN_LIST_COMMUNICATIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    roadId: undefined,
    concessionId: undefined,
    interlocutorGroupId: undefined,
    fromDate: undefined,
    toDate: undefined,
    orderBy: 'desc',
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_COMMUNICATIONS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_COMMUNICATIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    roadId: undefined,
    concessionId: undefined,
    interlocutorGroupId: undefined,
    fromDate: undefined,
    toDate: undefined,
    orderBy: 'desc',
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.WORKORDER_GENERAL_VIEW]: {
    id: tableIds.WORKORDER_GENERAL_VIEW,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.DUPLICATE_GENERIC_ORDER]: {
    id: tableIds.DUPLICATE_GENERIC_ORDER,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_WORKORDERS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_WORKORDERS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_ACTIONS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.ACCIDENTS]: {
    id: tableIds.ACCIDENTS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    weatherId: undefined,
    mediumKnowledgeId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerId: undefined,
    // Fase 4 nav Trabajo/Revisión — filtro "Origen" (tabla GLOBAL).
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Pestaña "Accidents" del LISTADO de Campañas (`GeneralViewCampaignPage`)
  // — espejo de ACCIDENTS pero con `containerTypes`.
  [tableIds.CAMPAIGN_LIST_ACCIDENTS]: {
    id: tableIds.CAMPAIGN_LIST_ACCIDENTS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    weatherId: undefined,
    mediumKnowledgeId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.CAMPAIGNS]: {
    id: tableIds.CAMPAIGNS,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    name: undefined,
    predefinedOrderId: undefined,
    fromDate: undefined,
    toDate: undefined,
    concessionId: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    teamId: undefined,
    track: undefined,
    onlyFlagged: undefined,
  },
  // Restaurado del merge-base 2026-07-04 (regresión de merge: la resolución
  // borró esta entrada y Campañas Históricas crasheaba junto al getCursor
  // sin fallback).
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_CAMPAIGNS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_CAMPAIGNS,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    name: undefined,
    predefinedOrderId: undefined,
    fromDate: undefined,
    toDate: undefined,
    concessionId: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    teamIds: undefined,
    track: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.MULTIMEDIA]: {
    id: tableIds.MULTIMEDIA,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    type: undefined,
    fromDate: undefined,
    toDate: undefined,
    state: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    isMultimedia: true,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerId: undefined,
    // Fase 4 nav Trabajo/Revisión — filtro "Origen" (tabla GLOBAL).
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Fase 3 nav Trabajo/Revisión (rework, 2026-07-12) — espejo de MULTIMEDIA
  // para la pestaña "Multimedia" del LISTADO del módulo RV
  // (GeneralViewRoutePage). `containerTypes` (no `containerId`, no hay
  // container concreto): filtro por TIPO de origen, resincronizado por el
  // loader contextual en cada run.
  [tableIds.RV_MULTIMEDIA]: {
    id: tableIds.RV_MULTIMEDIA,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    type: undefined,
    fromDate: undefined,
    toDate: undefined,
    state: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    isMultimedia: true,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Pestaña "Multimedia" del LISTADO de Campañas (`GeneralViewCampaignPage`)
  // — espejo de MULTIMEDIA pero con `containerTypes`.
  [tableIds.CAMPAIGN_LIST_MULTIMEDIA]: {
    id: tableIds.CAMPAIGN_LIST_MULTIMEDIA,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    type: undefined,
    fromDate: undefined,
    toDate: undefined,
    state: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    isMultimedia: true,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.GENERIC_ORDER_MODAL]: {
    id: tableIds.GENERIC_ORDER_MODAL,
    take: takeModal,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    fromDate: undefined,
    toDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    teamId: undefined,
    predefinedOrderId: undefined,
    track: undefined,
  },
  [tableIds.CAMPAIGN_MODAL]: {
    id: tableIds.CAMPAIGN_MODAL,
    take: takeModal,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    name: undefined,
    fromDate: undefined,
    toDate: undefined,
    concessionId: undefined,
    state: undefined,
    teamId: undefined,
    track: undefined,
    predefinedOrderId: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
  },

  [tableIds.VALIDATION_ACTIONS]: {
    id: tableIds.VALIDATION_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
    track: undefined,
    activityId: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.GENERAL_ACTIONS]: {
    id: tableIds.GENERAL_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
    track: undefined,
    activityId: undefined,
    containerId: undefined,
    // Fase 4 nav Trabajo/Revisión — filtro "Origen" (tabla GLOBAL).
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Fase 3 nav Trabajo/Revisión (rework, 2026-07-12) — espejo de
  // GENERAL_ACTIONS para la pestaña "Actuacions" del LISTADO del módulo RV
  // (GeneralViewRoutePage). `containerTypes` (no `containerId`): filtro por
  // TIPO de origen, no por un recorrido concreto.
  [tableIds.RV_ACTIONS]: {
    id: tableIds.RV_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
    track: undefined,
    activityId: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  // Pestaña "Actuacions" del LISTADO de Campañas (`GeneralViewCampaignPage`)
  // — espejo de GENERAL_ACTIONS pero con `containerTypes`.
  [tableIds.CAMPAIGN_LIST_ACTIONS]: {
    id: tableIds.CAMPAIGN_LIST_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
    track: undefined,
    activityId: undefined,
    containerTypes: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_BUDGETS]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_BUDGETS,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    budgetItemCode: undefined,
    categoryCode: undefined,
    fromDate: undefined,
    toDate: undefined,
    indexExpedition: undefined,
    indexType: undefined,
    concessionId: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    externalCompanyId: undefined,
  },
  [tableIds.SURVEILLANCE_ROUTES]: {
    id: tableIds.SURVEILLANCE_ROUTES,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
    onlyFlagged: undefined,
  },
  // Transfer básica→RV (2026-07-21): cursor de la tabla de RVs destino del
  // TransferSubOrderModal en modo RV — espejo de SURVEILLANCE_ROUTES con el
  // take de modal (+1 para absorber la exclusión del RV padre actual).
  [tableIds.SURVEILLANCE_ROUTE_MODAL]: {
    id: tableIds.SURVEILLANCE_ROUTE_MODAL,
    take: takeModalSurveillanceRoute,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
  },
  [tableIds.DASHBOARD_ACTIVE_ORDERS]: {
    id: tableIds.DASHBOARD_ACTIVE_ORDERS,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
  },
  [tableIds.SEARCH_AND_CREATE_HISTORICAL_SURVEILLANCE_ROUTES]: {
    id: tableIds.SEARCH_AND_CREATE_HISTORICAL_SURVEILLANCE_ROUTES,
    take: takeBase,
    cursor: '',
    description: undefined,
    concessionId: undefined,
    teamId: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    predefinedOrderId: undefined,
    orderBy: 'desc',
    toDate: undefined,
    fromDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    state: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.REPORTING_ACTIONS]: {
    id: tableIds.REPORTING_ACTIONS,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    concessionId: undefined,
    fromDate: undefined,
    toDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    state: undefined,
    teamIds: undefined,
    externalCompanyId: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    track: undefined,
    activityId: undefined,
    onlyFlagged: undefined,
  },
  [tableIds.REPORTING_ACCIDENTS]: {
    id: tableIds.REPORTING_ACCIDENTS,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    concessionId: undefined,
    weatherId: undefined,
    mediumKnowledgeId: undefined,
    fromDate: undefined,
    toDate: undefined,
    indexType: undefined,
    indexExpedition: undefined,
    classification: undefined,
    predefinedOrderId: undefined,
    laneCutting: undefined,
    materialIds: undefined,
    hasMaterials: undefined,
    capitolId: undefined,
    subCapitolId: undefined,
    state: undefined,
    teamIds: undefined,
    pkInitKm: undefined,
    pkInitMeter: undefined,
    pkEndKm: undefined,
    pkEndMeter: undefined,
    onlyFlagged: undefined,
  },
  // Restaurado del merge-base 2026-07-04 (misma regresión de merge).
  [tableIds.REPORTING_TIME_MANAGEMENT]: {
    id: tableIds.REPORTING_TIME_MANAGEMENT,
    take: takeBase,
    cursor: '',
    description: undefined,
    orderBy: 'desc',
    fromDate: undefined,
    toDate: undefined,
    teamIds: undefined,
    userIds: undefined,
    externalCompanyIds: undefined,
    states: undefined,
  },
};

type actionType = {
  type: string;
  payload: {
    id: string;
    data: {
      take?: number | undefined;
      cursor?: string | undefined;
      roadId?: string | undefined;
      concessionId?: string | undefined;
      teamId?: string | undefined;
      teamIds?: string[] | undefined;
      userIds?: string[] | undefined;
      states?: string[] | undefined;
      externalCompanyIds?: string[] | undefined;
      containerTypes?: string[] | undefined;
      containerId?: string | undefined;
      interlocutorGroupId?: string | undefined;
      fromDate?: string | undefined;
      toDate?: string | undefined;
      // Segundo rango de fechas, sobre la fecha de CIERRE (2026-08-11). Hoy
      // solo lo usa el modal «Vincular tramo»: un tramo tiene inicio y fin y
      // sala necesita poder acotar por cualquiera de los dos.
      fromEndDate?: string | undefined;
      toEndDate?: string | undefined;
      orderBy?: 'desc' | 'asc' | undefined;
      sortField?: string | undefined;
      indexType?: number | undefined;
      indexExpedition?: number | undefined;
      classification?: string | undefined;
      capitolId?: string | undefined;
      subCapitolId?: string | undefined;
      state?: string | undefined;
      mediumKnowledgeId?: string | undefined;
      weatherId?: string | undefined;
      type?: string | undefined;
      budgetItemCode?: string | undefined;
      categoryCode?: string | undefined;
      name?: string | undefined;
      description?: string | undefined;
      pkInitKm?: number | undefined;
      pkInitMeter?: number | undefined;
      pkEndKm?: number | undefined;
      pkEndMeter?: number | undefined;
      externalCompanyId?: string | undefined;
      laneCutting?: boolean | undefined;
      materialIds?: string[] | undefined;
      hasMaterials?: boolean | undefined;
    };
  };
};

export default function cursorTables(
  state = initialCursorState,
  { type, payload }: actionType & { payload?: any }
) {
  switch (type) {
    case REHYDRATE: {
      // Merge persisted state with initialCursorState so that new table keys
      // added after a user's last session are always present (no undefined cursors).
      const rehydrated = (payload as any)?.cursorTables;
      return rehydrated
        ? ({ ...initialCursorState, ...rehydrated } as typeof initialCursorState)
        : state;
    }
    case SET_CURSOR: {
      log('🔄 SET_CURSOR - payload:', payload);
      // Merge sobre el cursor previo (no REPLACE) — port del fix de main
      // 041dd304, PERDIDO en un merge de sincronización de esta rama
      // (regresión detectada 2026-07-12: el toggle "incluir inactivos" se
      // desmarcaba al Buscar). Antes el reducer hacía replace y los handlers
      // que despachaban dataCursor parcial borraban filtros no mencionados
      // como states/userIds/includeInactive. Con merge, cada handler solo
      // necesita declarar los campos que CAMBIA; los demás se preservan.
      // onClearValue sigue funcionando porque setea explícitamente
      // `state: undefined, states: undefined, userIds: undefined, ...`.
      const previousCursor = state[payload.id] ?? { id: payload.id };
      const mergedCursor = {
        ...previousCursor,
        id: payload.id,
        ...payload.data,
      };
      // INVARIANTE: cursor vacío ⇒ dirección forward. El take negativo solo es
      // válido junto a un cursor pivote (paginación backward). Si un dispatcher
      // resetea a página 1 (`cursor: ''`) sin declarar `take` (p.ej. ordenar
      // por columna), el merge preservaría el `take: -25` de una paginación
      // backward previa y el SERVIDOR devolvería la COLA del dataset como
      // "página 1" (Prisma con take negativo lee desde el final) → caché
      // corrupta. mergeCache/readCache ya normalizan en lectura; aquí se impone
      // en el estado para que ningún fetch salga con take<0 y cursor vacío.
      if (
        mergedCursor.cursor === '' &&
        typeof mergedCursor.take === 'number' &&
        mergedCursor.take < 0
      ) {
        mergedCursor.take = Math.abs(mergedCursor.take);
      }
      const newState = {
        ...state,
        [payload.id]: mergedCursor,
      };
      log('🔄 SET_CURSOR - newState for', payload.id, ':', (newState as Record<string, unknown>)[payload.id]);
      return newState;
    }
    default:
      return state;
  }
}
